import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("draw_mode", name, data);

export const shapeActionMenuItemClicked = (itemName: string) =>
  event("action_menu_item_clicked", { chipName: itemName });

export const drawShapeSelected = () => event("shape_selected");

export const drawTextEdited = () => event("text_edited");

export const drawAlignEdited = () => event("align_edited");
